<div>
  <div class="single-double-main">
    @for (image of item?.content; track image) {
      <div class="flex-one">
        <div
          class="single-double-image"
          [ngClass]="{ 'multiple-images': $safeNavigationMigration(item?.content?.length) > 1 }"
          [style.background-image]="'url(' + image.link + ')'"
          [style.height.px]="item?.height"
          [style.max-height.vh]="isResponsive ? 20 : ''"></div>
        <div class="single-double-button">
          @if (contentEdit) {
            <coin-v2-button
              type="secondary"
              class="single-double-button-item"
              icon="edit"
              [iconPos]="'right'"
              [text]="'cms.emails.change-image-button' | translate"
              (click)="editPicture(image)"></coin-v2-button>
          }
          @if (contentEdit && editImageLink) {
            <coin-v2-text-input
              matFormFieldClass="shadow"
              [label]="'cms.image-url' | translate"
              [(ngModel)]="image.anchorLink" />
          }
        </div>
      </div>
    }
  </div>
</div>

<div style="display: flex; gap: 8px">
  @if (contentEdit) {
    <mat-form-field appearance="fill">
      <mat-label>{{ 'cms.amount-images' | translate }}</mat-label>
      <mat-select
        [(ngModel)]="amountImages"
        (selectionChange)="amountChange($event.value)">
        @for (option of amountOptions; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (contentEdit && item) {
    <coin-v2-number-input
      aria-label="image height"
      [label]="'cms.content-pages.image-height' | translate"
      [placeholder]="'150'"
      [(ngModel)]="item.height" />
  }
</div>
@if (contentEdit && showBackgroundPicker && item) {
  <div class="background-color-picker">
    <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
  </div>
  <coin-email-slider
    label="Space-Top"
    [(ngModel)]="item.paddingTop"></coin-email-slider>
  <coin-email-slider
    label="Space-Bottom"
    [(ngModel)]="item.paddingBottom"></coin-email-slider>
}
